import { ChangeDetectionStrategy, Component } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@ngneat/transloco";
import * as i2 from "@angular/common";
import * as i3 from "../../shared/components/picture/picture.component";
import * as i4 from "@fortawesome/angular-fontawesome";
function FooterComponent_footer_0_a_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const link_r480 = ctx.$implicit;
    const t_r477 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("href", link_r480.href, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(t_r477("links." + link_r480.text));
} }
const _c0 = function (a1) { return ["fab", a1]; };
function FooterComponent_footer_0_a_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 9);
    i0.ɵɵelement(1, "fa-icon", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const link_r482 = ctx.$implicit;
    i0.ɵɵclassMapInterpolate1("social ", link_r482.icon, "");
    i0.ɵɵproperty("href", link_r482.href, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction1(5, _c0, link_r482.icon));
} }
function FooterComponent_footer_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "footer");
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵelementStart(2, "span", 2);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 3);
    i0.ɵɵtemplate(5, FooterComponent_footer_0_a_5_Template, 2, 2, "a", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 5);
    i0.ɵɵelementStart(7, "span");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div");
    i0.ɵɵelement(10, "app-picture", 6);
    i0.ɵɵelementStart(11, "span");
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 7);
    i0.ɵɵtemplate(14, FooterComponent_footer_0_a_14_Template, 2, 7, "a", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const t_r477 = ctx.$implicit;
    const ctx_r476 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(t_r477("copyrights"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r476.links);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(t_r477("call.text"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(t_r477("call.phone"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r476.socials);
} }
export class FooterComponent {
    constructor() {
        this.links = [
            { text: 'about', href: 'https://www.powermyanalytics.com/about/' },
            { text: 'affiliates', href: 'https://www.powermyanalytics.com/affiliates/' },
            { text: 'contact', href: 'https://www.powermyanalytics.com/contact/' },
            { text: 'support', href: 'https://support.powermyanalytics.com/portal/kb' },
            { text: 'privacy', href: 'https://www.powermyanalytics.com/privacy/' },
            { text: 'terms', href: 'https://www.powermyanalytics.com/terms/' },
            { text: 'updates', href: 'https://www.powermyanalytics.com/updates/' },
        ];
        this.socials = [
            { icon: 'linkedin-in', href: 'https://www.linkedin.com/company/power-my-analytics/' },
            { icon: 'twitter', href: 'https://twitter.com/ShowMeROI' },
            { icon: 'facebook-f', href: 'https://www.facebook.com/PowerMyAnalytics/' },
        ];
    }
    ngOnInit() {
    }
}
FooterComponent.ɵfac = function FooterComponent_Factory(t) { return new (t || FooterComponent)(); };
FooterComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FooterComponent, selectors: [["app-footer"]], decls: 1, vars: 1, consts: [[4, "transloco", "translocoRead"], [1, "container"], ["id", "copyrights"], ["id", "links"], [3, "href", 4, "ngFor", "ngForOf"], ["id", "call"], ["srcset", "assets/images/us-flag", "alt", "us-flag"], ["id", "socials"], [3, "href", "class", 4, "ngFor", "ngForOf"], [3, "href"], [3, "icon"]], template: function FooterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, FooterComponent_footer_0_Template, 15, 5, "footer", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("translocoRead", "app.footer");
    } }, directives: [i1.TranslocoDirective, i2.NgForOf, i3.PictureComponent, i4.FaIconComponent], styles: ["footer[_ngcontent-%COMP%]{background-color:#eceff1}footer[_ngcontent-%COMP%] > .container[_ngcontent-%COMP%]{display:grid;padding:32px 32px 128px}footer[_ngcontent-%COMP%]   #copyrights[_ngcontent-%COMP%]{grid-area:copyrights;font-size:14px;line-height:24px}@media(min-width:576px){footer[_ngcontent-%COMP%]   #copyrights[_ngcontent-%COMP%]{font-size:16px}}footer[_ngcontent-%COMP%]   #links[_ngcontent-%COMP%]{grid-area:links;display:-webkit-inline-box;display:inline-flex;font-size:14px;line-height:24px}footer[_ngcontent-%COMP%]   #links[_ngcontent-%COMP%] > *[_ngcontent-%COMP%] + *[_ngcontent-%COMP%]{-webkit-margin-start:16px;margin-inline-start:16px}footer[_ngcontent-%COMP%]   #links[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{color:rgba(0,0,0,.54);text-decoration:none}footer[_ngcontent-%COMP%]   #links[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{color:rgba(0,0,0,.87)}@media(max-width:575.98px){footer[_ngcontent-%COMP%] > .container[_ngcontent-%COMP%]{grid-template-areas:\"copyrights\" \"socials\" \"call\"}footer[_ngcontent-%COMP%]   #copyrights[_ngcontent-%COMP%]{text-align:center}footer[_ngcontent-%COMP%]   #links[_ngcontent-%COMP%]{display:none}}@media(min-width:576px)and (max-width:991.98px){footer[_ngcontent-%COMP%] > .container[_ngcontent-%COMP%]{grid-template-areas:\"copyrights\" \"socials\" \"call\" \"links\"}footer[_ngcontent-%COMP%]   #copyrights[_ngcontent-%COMP%]{text-align:center}footer[_ngcontent-%COMP%]   #links[_ngcontent-%COMP%]{margin-top:48px;-webkit-box-pack:center;justify-content:center}}@media(min-width:992px){footer[_ngcontent-%COMP%] > .container[_ngcontent-%COMP%]{grid-template-areas:\"copyrights links\" \"call socials\"}footer[_ngcontent-%COMP%]   #links[_ngcontent-%COMP%]{font-size:16px;-webkit-box-pack:end;justify-content:flex-end}}#call[_ngcontent-%COMP%]{grid-area:call;margin-top:32px;text-align:center;line-height:29px;font-size:16px;display:-webkit-box;display:flex}@media(max-width:991.98px){#call[_ngcontent-%COMP%]{-webkit-box-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}}@media(min-width:992px){#call[_ngcontent-%COMP%]{-webkit-box-align:start;align-items:flex-start}}#call[_ngcontent-%COMP%]   app-picture[_ngcontent-%COMP%]{display:inline-block;vertical-align:-6px;-webkit-margin-end:8px;margin-inline-end:8px}#call[_ngcontent-%COMP%] > *[_ngcontent-%COMP%] + *[_ngcontent-%COMP%]{-webkit-margin-start:8px;margin-inline-start:8px}#socials[_ngcontent-%COMP%]{grid-area:socials;margin-top:32px;display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center}@media(min-width:992px){#socials[_ngcontent-%COMP%]{-webkit-box-pack:end;justify-content:flex-end}}#socials[_ngcontent-%COMP%] > *[_ngcontent-%COMP%] + *[_ngcontent-%COMP%]{-webkit-margin-start:8px;margin-inline-start:8px}.social[_ngcontent-%COMP%]{background-color:#fff;border-radius:100%;line-height:44px;width:44px;text-align:center;font-size:18px;-webkit-transition:50ms;transition:all 50ms ease}.social.linkedin-in[_ngcontent-%COMP%]{color:#0e76a8}.social.twitter[_ngcontent-%COMP%]{color:#00acee}.social.facebook-f[_ngcontent-%COMP%]{color:#3b5998}.social[_ngcontent-%COMP%]:hover{border-radius:10%;background-color:#ff9800;color:#fff}"], changeDetection: 0 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(FooterComponent, [{
        type: Component,
        args: [{
                selector: 'app-footer',
                templateUrl: './footer.component.html',
                styleUrls: ['./footer.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return []; }, null); })();
